import { easyclaHelp } from '@config';
import {
  Component,
  Output,
  ChangeDetectionStrategy,
  EventEmitter,
} from '@angular/core';
import { IntercomService } from '@services';

@Component({
  selector: 'lfx-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpMenuComponent {
  @Output() getPageHelp = new EventEmitter<
    typeof easyclaHelp['easyClaHelpPaths']
  >();

  helpPaths = easyclaHelp.easyClaHelpPaths;

  constructor(private intercomService: IntercomService) {}

  openSupport() {
    this.intercomService.show();
  }
}
